<template>
  <div class="load_cover" :class="isAnimatedLoadCover ? 'animated' : ''">
    <div class="center_image">
      <img src="@/assets/image/load.gif">
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "LoadCover",

    computed: {
      ...mapGetters({isAnimatedLoadCover: 'cover/isAnimatedLoadCover'}),
    },
  }
</script>

<style lang="scss" scoped>
  .load_cover {
    @include cover;
    @extend .fade_in;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>